import { createContext, useContext, type ReactNode } from "react";
import { trpc } from "../lib/trpc";
import type { SessionUser } from "../../../shared/types";

interface AuthValue {
  user: SessionUser | null;
  isLoading: boolean;
  refetch: () => void;
}

const AuthContext = createContext<AuthValue | undefined>(undefined);

export function AuthProvider({ children }: { children: ReactNode }) {
  const meQ = trpc.auth.me.useQuery(undefined, { staleTime: 60_000 });

  return (
    <AuthContext.Provider
      value={{
        user: (meQ.data ?? null) as SessionUser | null,
        isLoading: meQ.isLoading,
        refetch: () => void meQ.refetch(),
      }}
    >
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error("useAuth must be inside <AuthProvider>");
  return ctx;
}
